import React from 'react';
import VendorContent from 'containers/request/Initial/VendorRequestContent';
import LabContent from 'containers/request/RequestContent/LabView';
import roles from 'dictionaries/UserRoles';

const RequestPageContent = ({ role }) => {
  switch (role) {
    case roles.staff:
    case roles.vendor:
    case roles.accountant:
      return <VendorContent />;
    case roles.lab:
      return <LabContent />;
    default:
      return null;
  }
};

export default RequestPageContent;



// WEBPACK FOOTER //
// ./src/containers/request/Initial/RequestPageContent.js